import { typeahead } from "@mirage/service-typeahead-search/service/types";
import i18n from "@mirage/translations";

/**
 * This hook is used to manage the omnibox input mode
 */

export const useOmniboxInputMode = ({
  isSlimMode = false,
  omniboxScopedMode,
}: {
  isSlimMode?: boolean;
  omniboxScopedMode: typeahead.Mode;
}) => {
  const OMNIBOX_SCOPED_MODE_TO_PLACEHOLDER_MAP = {
    [typeahead.Mode.Default]: i18n.t("omnibox_mode_find_anything"),
    [typeahead.Mode.Find]: i18n.t("omnibox_mode_find"),
    [typeahead.Mode.Ask]: i18n.t("omnibox_mode_ask"),
    [typeahead.Mode.Write]: i18n.t("omnibox_mode_write"),
    [typeahead.Mode.Organize]: i18n.t("omnibox_mode_organize"),
  };

  const omniboxPlaceholder =
    OMNIBOX_SCOPED_MODE_TO_PLACEHOLDER_MAP[omniboxScopedMode];
  const showBackButton =
    omniboxScopedMode !== typeahead.Mode.Default && !isSlimMode;

  return {
    omniboxScopedMode,
    omniboxPlaceholder,
    showBackButton,
  };
};
